import React from 'react'
import styled from '@emotion/styled'
import InlineSVG from 'svg-inline-react'

import { useAuth0 } from 'shared/utils/auth0'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import * as Selectors from 'state/selectors'

import iconSignOut from 'assets/icons/ico-signout.svg'
import iconSettings from 'assets/icons/ico-settings.svg'
import iconFlow from 'assets/icons/ico-flow.svg'

const Wrapper = styled.div`
`

const ItemWrapper = styled.div`
  padding: 0 5px;

  display: flex;
  flex-direction: row;
  align-content: center;
  user-select: none;
  cursor: pointer;
  opacity: .9;
  
  transition: all .2s ease;
  
  &:hover {
   opacity: 1;
   box-shadow: 0 0 19px -8px rgba(0, 0, 0, 0.75);
  }
`

const ItemTitle = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  color: rgba(0, 0, 0, 0.8)
`

const Icon = styled(InlineSVG)`
  transform: scale(.7);
`

const NavHeaderMenu = () => {
  const { logout } = useAuth0()
  const history = useHistory()
  const hasAdminPermissions = useSelector(Selectors.hasAdminPermissions)

  return (
    <Wrapper>
      {hasAdminPermissions && (
        <>
          <ItemWrapper
            onClick={() => {
              window.location.href = process.env.DASHBOARD_URI
            }}
          >
            <Icon src={iconFlow} />

            <ItemTitle>
              Back to Flow.ai
            </ItemTitle>
          </ItemWrapper>

          <ItemWrapper
            onClick={() => {
              history.push(`${process.env.CHAT_PUBLIC_PATH}/settings`)
            }}
          >
            <Icon src={iconSettings} />

            <ItemTitle>
              Settings
            </ItemTitle>
          </ItemWrapper>
        </>
      )}

      <ItemWrapper
        onClick={() => {
          history.push(`${process.env.CHAT_PUBLIC_PATH}/settings/organisations`)
        }}
      >
        <Icon src={iconSettings} />

        <ItemTitle>
          Change organisation
        </ItemTitle>
      </ItemWrapper>

      <ItemWrapper
        onClick={() => logout({
          returnTo: process.env.AUTH0_REDIRECT_URI
        })}
      >
        <Icon src={iconSignOut} />

        <ItemTitle>
          Sign out
        </ItemTitle>
      </ItemWrapper>
    </Wrapper>
  )
}

export default NavHeaderMenu
